module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("Henry Holt and Company, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Publishers since 1866")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("175 Fifth Avenue")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("New York, New York 10010")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "href": "http://www.HenryHoltKids.com",
      "target": "_blank"
    }
  }, [_vm._v("www.HenryHoltKids.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Henry Holt"), _c('sup', [_vm._v("®")]), _vm._v(" is a registered trademark of Henry Holt and Company, LLC.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2009 by Marissa Doyle")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Distributed in Canada by H. B. Fenn and Company Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Doyle, Marissa.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Betraying season / Marissa Doyle.—1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("p.    cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Summary: In 1838, Penelope Leland goes to Ireland to study magic and prove to herself that she is as good a witch as her twin sister Persy, but when Niall Keating begins to pay her court, she cannot help being distracted.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN-13: 978-0-8050-8252-4")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN-10: 0-8050-8252-2")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("[1. Witches—Fiction. 2. Magic—Fiction. 3. Courtship—Fiction. 4. Ireland—History—1837–1901—Fiction. 5. Great Britain—History—Victoria, 1837–1901—Fiction.] I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("PZ7.D7758Bet 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("[Fic]—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("2008040593")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("First Edition—2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed in the United States of America on acid-free paper.∞")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("1   3   5   7   9   10   8   6   4   2")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49af5c96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0